"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Base_1 = require("./Base");
var PromiseClient = /** @class */ (function (_super) {
    __extends(PromiseClient, _super);
    function PromiseClient(userOption) {
        if (userOption === void 0) { userOption = {}; }
        var _this = _super.call(this, userOption) || this;
        _this.promiseMap = new Map();
        _this.eventEmitter.on('packet', function (packet) {
            // console.log(packet, 'packet');
            var requestId = _this.option.mapRequestId(packet);
            if (requestId && _this.promiseMap.has(requestId)) {
                var _a = _this.promiseMap.get(requestId), resolve = _a.resolve, reject = _a.reject;
                _this.promiseMap.delete(requestId);
                var result = _this.option.mapResult(packet);
                if (result === true) {
                    resolve(packet);
                }
                else {
                    reject(packet);
                }
            }
        });
        _this.eventEmitter.on('close', function () {
            _this.rejectAll();
        });
        return _this;
    }
    PromiseClient.prototype.rejectAll = function () {
        this.promiseMap.forEach(function (p) {
            p.reject('reject by close');
        });
        this.promiseMap = new Map();
    };
    PromiseClient.prototype.promiseSend = function (data, timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = this.option.timeout; }
        var requestId = this.option.mapRequestId(data);
        if (requestId) {
            return new Promise(function (resolve, reject) {
                _this.promiseMap.set(requestId, {
                    resolve: resolve,
                    reject: reject
                });
                typeof timeout === 'number' && timeout && setTimeout(function () { return reject('timeout'); }, timeout);
                _this.send(data);
            });
        }
        return new Promise(function (resolve) {
            _this.send(data);
            resolve(true);
        });
    };
    return PromiseClient;
}(Base_1.BaseClient));
exports.PromiseClient = PromiseClient;
//# sourceMappingURL=PromiseClient.js.map